// extracted by mini-css-extract-plugin
export var languageSelector = "LanguageSelector-module--languageSelector--2elXH";
export var languageBtn = "LanguageSelector-module--languageBtn--3BI4a";
export var de = "LanguageSelector-module--de--3LV_s";
export var en = "LanguageSelector-module--en--17mWw";
export var hu = "LanguageSelector-module--hu--1gisr";